import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useState } from 'react';
import { Tooltip } from '@mui/material';
import useUpdateAccountAliases from 'src/api/core/finance/useUpdateAccountAliases';
import { PillInput } from '../common/pills/PillInput';
import { PillList } from '../common/pills/PillList';

// Helper component for displaying/editing aliases
const AliasesBox: React.FC<{
  customerId: string;
  values?: string[] | null;
  onUpdate?: () => void;
}> = ({ customerId, values, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(values ?? []);

  const {
    mutate: updateAccountAliases,
    isLoading: isUpdatingAliases,
    error: updateAccountAliasesError,
  } = useUpdateAccountAliases(customerId, () => {
    onUpdate?.();
  });

  const handleSave = () => {
    const newValues = editValue.filter((line) => line.trim() !== '');
    updateAccountAliases({ aliases: newValues });
    setIsEditing(false);
  };

  return (
    <MDBox mb={2} display="flex" flexDirection="column" gap={1}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="caption" color="text" fontWeight="bold">
          Aliases
        </MDTypography>
        {isUpdatingAliases ? (
          <HourglassBottomOutlinedIcon
            sx={{ cursor: 'not-allowed', fontSize: 16 }}
            color="info"
          />
        ) : updateAccountAliasesError ? (
          <Tooltip
            title={
              updateAccountAliasesError?.status || 'Error updating aliases'
            }
          >
            <ErrorOutlineIcon
              sx={{ cursor: 'pointer', fontSize: 16 }}
              color="error"
              onClick={() => setIsEditing(true)}
            />
          </Tooltip>
        ) : isEditing ? (
          <DoneIcon
            sx={{ cursor: 'pointer', fontSize: 16 }}
            color="info"
            onClick={handleSave}
          />
        ) : (
          <EditIcon
            sx={{ cursor: 'pointer', fontSize: 16 }}
            color="info"
            onClick={() => setIsEditing(true)}
          />
        )}
      </MDBox>
      {isEditing ? (
        <PillInput
          values={editValue}
          onChange={(values) => setEditValue(values)}
        />
      ) : (
        <PillList values={values ?? []} />
      )}
    </MDBox>
  );
};

export default AliasesBox;
